import { request, proto } from '../main'

const basicApi = {}

basicApi.getAllLocation = query => {
  const pbReq = proto.create('framework.PBLocationGetAllReq', query)
  return request('locationGetAll', pbReq, 'PBLocationData')
}

basicApi.getBasicConfig = () => {
  return request('basicConfigGet', null, 'PBBasicConfig')
}

basicApi.getLocationLntLat = query => {
  const pbReq = proto.create('framework.PBGetLocationLntLat', query)
  return request('locationGetLngLat', pbReq, 'PBLocationLntLat')
}

basicApi.getLocationById = locationId => {
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(locationId)
  })
  return request('locationGetById', pbReq, 'PBLocation')
}

basicApi.getSystemConfig = str => {
  const pbReq = proto.create('framework.PBStrValue', {
    value: str
  })
  return request('systemParaGetOne', pbReq, 'PBSystemParaConfig')
}

basicApi.getPartnerList = query => {
  const pbReq = proto.create('framework.PBPartnerSearchReq', query)
  return request('partnerList', pbReq, 'PBPartnerList')
}

export default basicApi



// WEBPACK FOOTER //
// ./src/api/basic.js